<template>
  <div>
     <div class="fixed-top-bar d-flex align-center">
      <v-row>
        <!-- <v-col cols="1">
          <v-btn icon dark disabled="">
            <v-icon size="28px"> mdi-arrow-left-bold-box-outline </v-icon>
          </v-btn>
        </v-col> -->
        <v-col cols="3">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                v-bind="attrs"
                v-on="on"
                @click="dialog = true"
                :disabled="selectedRows.length > 0"
                class="ml-7 header_btn"
              >
                <v-icon size="28px"> mdi-file-plus-outline </v-icon>
                <span class="lable_class">Add</span>
              </v-btn>
            </template>
            <span>Add</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                v-bind="attrs"
                v-on="on"
                disabled
                class="ml-7 header_btn"
              >
                <v-icon size="28px"> mdi-clipboard-edit-outline </v-icon>
                <span class="lable_class">Edit</span>
              </v-btn>
            </template>
            <span>Edit</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon dark v-bind="attrs" v-on="on" disabled
              class="ml-7 header_btn">
                <v-icon size="28px"> mdi-eye-outline </v-icon>
                <span class="lable_class">View</span>
              </v-btn>
            </template>
            <span>View</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                v-bind="attrs"
                v-on="on"
                class="ml-7 header_btn"
                :disabled="selectedRows.length == 0"
                @click="delete_dialog = true"
              >
                <v-icon size="28px"> mdi-delete-outline </v-icon>
                <span class="lable_class">Delete</span>
              </v-btn>
            </template>
            <span>Delete</span>
          </v-tooltip>
        </v-col>
        <v-col cols="6">
           <v-menu bottom offset-y :close-on-content-click="false" v-model="search_menu">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon small dark v-bind="attrs" v-on="on" class="header_btn">
                 <span class="lable_class">Search</span>
                 <v-badge overlap dot :value="search" color="error">
                  <v-icon size="28px">mdi-magnify</v-icon>
                </v-badge>
              </v-btn>
            </template>
            <v-card tile width="300">
              <v-row no-gutters>
            <v-col cols="12" class="">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
                dense
                solo
                clearable
                v-on:keyup.enter="search_menu = false"
                autofocus
              ></v-text-field>
            </v-col>
          </v-row>
            </v-card>
           </v-menu>
           <v-menu bottom :close-on-content-click="false" content-class="elevation-0" v-model="filter_menu">
            <template v-slot:activator="{ on, attrs }">
              <v-btn disabled="" dark icon v-bind="attrs" v-on="on" class="ml-7 header_btn">
                  <v-icon size="22px">mdi-filter-menu-outline</v-icon>
                  <span class="lable_class">Filter</span>
              </v-btn>
            </template>
          </v-menu>
        </v-col>
        <v-col cols="3" class="d-flex align-center justify-end">
          <span class="white--text font-weight-bold">Role & Permission <v-icon class="error--text ml-2" size="30" style="color:#ffffff !important" @click="logout()" >mdi-logout</v-icon></span>
        </v-col>
      </v-row>
    </div>
    <v-overlay absolute :value="loading">
          <v-icon style="font-size: 80px;">mdi-progress-clock mdi-spin</v-icon>
        </v-overlay>
    <v-card flat tile>
      
      <v-card-text
        class="pa-0 mx-auto"
      >
        <v-data-table
          :headers="headers"
          class="elevation-1 rounded-0 my-transaction-table small-table fix-table-layout fix-table-header custom-width-550"
          item-key="role_id"
          :search="search"
          :items="items.data"
          :server-items-length="items.total"
          :options.sync="pagination"
          mobile-breakpoint="50"
          dense
          :footer-props="{
            'items-per-page-options': pagination_settings.perPageList,
          }"
        >
          <template v-slot:item="{ item }">
            <tr>
              <td width="7%">
                <v-icon @click="editRecord(item.role_id)">
                  mdi-clipboard-edit-outline
                </v-icon>
              </td>
              <td width="7%">
                <v-simple-checkbox
                  v-model="item.selected"
                  :ripple="false"
                  class="custom-simple-box"
                ></v-simple-checkbox>
              </td>
              <td width="64%">
                {{item.name}}
              </td>
              <td width="22%">
                  <a href="javascript:void(0)" @click="access_right_dialog = true; selected_role_data = item">
                    AccessRights
                  </a>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <v-dialog v-model="dialog" persistent max-width="300px">
      <v-card :loading="form_loading">
        <v-card-title>
          <span class="headline">Add Role</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row dense>
              <v-text-field
                label="Role Name*"
                v-model="form_data.name"
                :error-messages="form_error.name"
                :hide-details="!form_error.name"
              ></v-text-field>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="dialog = false;form_data = {};form_error = {}">
            Close
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="addRole"> Save </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="edit_dialog" persistent max-width="300px">
      <v-card :loading="form_loading">
        <v-card-title>
          <span class="headline">Update Role</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row dense>
              <v-text-field
                label="Role Name*"
                v-model="edit_form_data.name"
                :error-messages="edit_form_error.name"
                :hide-details="!edit_form_error.name"
              ></v-text-field>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error"
            @click="edit_dialog = false;edit_form_data = {};edit_form_error = {}">
            Close
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="updateRole" dark> Update </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="delete_dialog" max-width="400">
      <v-card>
        <v-card-title class="headline"> Confirmation </v-card-title>
        <v-card-text>
          Are you sure you want to delete selected roles?
        </v-card-text>
        <v-card-actions class="pa-0">
          <v-spacer></v-spacer>
          <v-btn color="dark darken-1" text @click="delete_dialog = false">
            Cancel
          </v-btn>
          <v-btn color="red darken-1" text @click="delete_dialog = false; deleteRoles()">
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <AccessRight :access_right_dialog="access_right_dialog" :selected_role_data="selected_role_data" @closeDialog="access_right_dialog = false"></AccessRight>
  </div>
</template>
<script>
import axios from "../../plugins/axios";
import { parseParams, logout} from "../../plugins/helper";
import { mapState, mapMutations } from "vuex";
import AccessRight from "../rolepermission/AccessRight";
export default {
  name: "Area",
  data() {
    return {
      dialog: false,
      edit_dialog:false,
      delete_dialog: false,
      form_loading: false,
      access_right_dialog: false,
      selected_role_data: {},
      form_data: {},
      form_error: {},
      edit_form_data: {},
      edit_form_error: {},
      role_id: null,
      search: "",
      loading: false,
      filter_menu: false,
      items: {
        data: [],
      },
      headers: [
        { value: "", text: "", sortable: false, width: '7%' },
        { value: "checkbox", text: "#", sortable: false, width: '7%' },
        { value: "name", text: "Role Name", sortable: true, width: '64%' },
        { value: "action", text: "", sortable: false, width: '22%' },
      ],
      pagination: {
        itemsPerPage: 25,
        sortBy: ["created_at"],
        page: 1,
      },
      search_menu : false
    };
  },
  components: {
    AccessRight
  },
  computed: {
    ...mapState("utils", ["pagination_settings"]),
    selectedRows() {
      return this.items.data.filter(function (item) {
        return item.selected == true;
      });
    },
    pageData() {
      let paginationData = this.pagination;
      paginationData.search = this.search;
      paginationData.searchOption = "name";
      return paginationData;
    },
  },
  watch: {
    search() {
      this.getRecords();
    },
    pagination: {
      handler: function () {
        this.getRecords();
      },
      deep: true,
    },
  },
  methods: {
    ...mapMutations("utils", ["setAlert"]),
    editRecord(role_id) {
      this.role_id = role_id;
      this.edit_dialog=true;
      this.getRoleDetails(role_id)
    },
    getRecords() {
      let _self = this;
      this.loading = "accent";
      let url = parseParams(this.pageData);
      axios.get("role_list?" + url)
        .then((response) => {
          if (_self.items.total != response.data.data.total) {
            _self.pagination.page = 1;
          }
          _self.items = response.data.data;
          _self.loading = false;
        })
        .catch(function () {
          _self.loading = false;
        });
    },
    addRole() {
      let _self = this;
      // this.loading = "accent";
      _self.form_loading = true;
      axios.post("add_role", _self.form_data)
        .then((response) => {
          _self.form_data = {};
          _self.form_error = {};
          let data = response.data;
          if (!data.status) {
            _self.form_loading = false;
            for (let key in data.errors) {
              _self.form_error[key] = data.errors[key][0];
            }
          } else {
            _self.form_loading = false;
            _self.dialog = false
            _self.getRecords()
            //_self.items.data.push(data.data)
          }
        })
        .catch(function () {
          _self.form_loading = false;
        });
    },
    updateRole(){
      let _self = this;
      _self.edit_form_data.role_id = _self.role_id
      axios.post("update_role", _self.edit_form_data)
        .then((response) => {
          _self.edit_form_data = {};
          _self.edit_form_error = {};
          let data = response.data;
          if (!data.status) {
            _self.form_loading = false;
            for (let key in data.errors) {
              _self.edit_form_error[key] = data.errors[key][0];
            }
          } else {
            _self.edit_form_data = {}
            _self.form_loading = false;
            _self.edit_dialog = false
            _self.getRecords();
          }
        })
        .catch(function () {
          _self.form_loading = false;
        });
    },
    getRoleDetails(role_id){
      let _self = this
      _self.form_loading= true;
      axios.get("get_role_details?role_id="+role_id)
        .then((response) => {
          _self.edit_form_data.name = response.data.data.name;
          _self.form_loading = false;
        })
        .catch(function () {
          _self.form_loading = false;
        });
    },
    deleteRoles(){
      let _self = this
      let ids = []
      this.selectedRows.map(function(item){
        ids.push(item.role_id)
      })
      axios.post("delete_roles",{
        ids : ids
      }).then(function(response){
         _self.setAlert({
          show: true,
          variant: response.data.variant,
          message: response.data.message,
          dismissCountDown: 0
        });
        _self.getRecords()
      })
      .catch(function(){
        console.log('FAILURE!!');
      });
    },
    logout() {
      logout(this.$router)
    }
  },
  mounted() {
    this.getRecords();
  },
};
</script>